<template>
  <svg :width="width" :height="height" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_55_211)">
      <g clip-path="url(#clip0_55_211)">
        <path d="M12 28C12 16.9543 20.9543 8 32 8V8C43.0457 8 52 16.9543 52 28V48H32C20.9543 48 12 39.0457 12 28V28Z" fill="#FAFAFA" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M35 37.5V34H40C40.552 34 41 33.552 41 33V20C41 19.448 40.552 19 40 19H24C23.448 19 23 19.448 23 20V33C23 33.552 23.448 34 24 34H30L35 37.513V37.5Z"
          :stroke="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path d="M35 29H27" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M27 24H37" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </g>
      <path d="M52 50H54V48V28C54 15.8497 44.1503 6 32 6C19.8497 6 10 15.8497 10 28C10 40.1503 19.8497 50 32 50H52Z" :stroke="color" stroke-width="4" />
    </g>
    <defs>
      <filter id="filter0_d_55_211" x="0" y="0" width="64" height="64" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_55_211" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_55_211" result="shape" />
      </filter>
      <clipPath id="clip0_55_211">
        <path d="M12 28C12 16.9543 20.9543 8 32 8V8C43.0457 8 52 16.9543 52 28V48H32C20.9543 48 12 39.0457 12 28V28Z" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'Icon3',
  props: {
    color: {
      type: String,
      default: '#000',
    },
    width: {
      type: Number,
      default: 96,
    },
    height: {
      type: Number,
      default: 96,
    },
  },
};
</script>
